import { render, staticRenderFns } from "./countup.vue?vue&type=template&id=77fb34c6&"
import script from "./countup.vue?vue&type=script&lang=js&"
export * from "./countup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports